import { useState } from 'react';
import { Col, Row } from 'reactstrap';
import Table, { useTable } from 'common/components/table';
import TableActions from 'components/layouts/table';
import EnumsDropdown from '../Dropdown';
import useDrawer from 'common/components/drawer/useDrawer';
import edit from 'common/assets/svg/actions/edit.svg';

import Drawer from './form';

const ClassificationSocieties = () => {
  const [active, setActive] = useState(null);

  const drawer = useDrawer(false);

  const table = useTable({
    label: 'classification_societies',
    columns: [
      {
        header: 'Name',
        key: 'name',
        type: 'string',
        sort: true,
        width: 3
      },
      {
        header: 'Short name',
        key: 'short_name',
        type: 'string',
        sort: true,
        width: 2
      },
      {
        header: 'Actions',
        key: 'actions',
        field: 'actions',
        className: 'text-center'
      }
    ]
  });

  return (
    <Row className="classification-societies-table">
      <Col xs={12} className="mb-6 mt-n1">
        <TableActions
          documentTitle="Classification Societies"
          title="Enums"
          dropdown={<EnumsDropdown />}
          actions={[{ type: 'search' }]}
        />
      </Col>
      <Col xs={12}>
        <Table
          loader
          drawer={<Drawer active={active} drawer={drawer} />}
          rows={{
            short_name: data => data.short_name || '-',
            actions: {
              options: [
                {
                  label: 'Edit',
                  icon: edit,
                  onClick: (_, row) => {
                    setActive(row);
                    drawer.open();
                  }
                }
              ]
            }
          }}
          {...table}
        />
      </Col>
    </Row>
  );
};

export default ClassificationSocieties;
